'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_LineageGraph(graph) {
  this.Fv = null;
  this.Fv = graph;
}
export { $c_Lapp_data_LineageGraph as $c_Lapp_data_LineageGraph };
$p = $c_Lapp_data_LineageGraph.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_LineageGraph;
/** @constructor */
function $h_Lapp_data_LineageGraph() {
}
export { $h_Lapp_data_LineageGraph as $h_Lapp_data_LineageGraph };
$h_Lapp_data_LineageGraph.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_LineageGraph)) {
    var x = this.Fv;
    var x$2 = x$0.Fv;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "LineageGraph";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Fv;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "graph";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_LineageGraph(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jG)));
}
export { $isArrayOf_Lapp_data_LineageGraph as $isArrayOf_Lapp_data_LineageGraph };
var $d_Lapp_data_LineageGraph = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_LineageGraph, "app.data.LineageGraph", ({
  jG: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_LineageGraph as $d_Lapp_data_LineageGraph };
//# sourceMappingURL=app.data.-Lineage-Graph.js.map
